<template>
    <div
        class="create-asset__input input input--md input--grey clearfix"
        :class="wrapClasses"
    >
        <label
            :for="name"
            class="create-asset__input-label"
            :class="validators.required ? 'create-asset__required' : ''"
        >
            {{ label }}
            <span>{{ amountOfCharacters }}</span>
        </label>

        <div :class="`create-asset__input-item ${enabled ? '' : 'readonly'}`">
            <Component
                :is="tag"
                :id="id || name"
                ref="input"
                v-validate="validate"
                :name="name"
                :enabled="enabled"
                :readonly="!enabled"
                :value.prop="value"
                :class="{ 'is-danger': errors.has(name) }"
                type="text"
                :placeholder="placeholder"
                :maxlength="validators.max"
                autocomplete="off"
                @input="updateValue($event.target.value)"
            />
        </div>

        <div class="create-asset__msg">
            <span
                v-show="errors.has(name)"
                class="create-asset__msg-error is-danger"
            >
                {{ errors.first(name) }}
            </span>
            <span v-if="type === 'string'" class="create-asset__msg-normal"
                >{{ Number(validators.max) - value.length }} characters
                left</span
            >
        </div>
    </div>
</template>

<script>
import debounce from 'lodash.debounce';

export default {
    props: {
        tag: {
            type: String,
            default: 'input',
        },
        id: {
            type: String,
            default: `item_${Math.random(999999999) +
                100000000}_${new Date().getTime()}`,
        },
        name: {
            type: String,
            required: true,
        },
        enabled: {
            type: Boolean,
            required: false,
            default: true,
        },
        value: {
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'string',
        },
        placeholder: String,
        validate: String,
        rounded: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        validators() {
            const obj = {};
            const options = this.validate
                .split('|')
                .map(item => item.split(':'));
            options.forEach(option => {
                obj[option[0]] = option.length === 1 ? true : option[1];
            });

            return obj;
        },
        amountOfCharacters() {
            const min = this.validators.min,
                max = this.validators.max;

            if (min && max) {
                return `(${min}-${max} characters)`;
            } else if (!min && max) {
                return `(max. ${max} characters)`;
            } else if (min && !max) {
                return `(min. ${min} characters)`;
            } else {
                return '';
            }
        },
        wrapClasses() {
            const classes = [];

            if (this.rounded) {
                classes.push('input--rounded');
            }

            return classes;
        },
        onChangeDebounced() {
            return debounce(this.onChange, 500);
        },
    },
    mounted() {
        if (this.tag === 'textarea') {
            this.checkIfScrollable(this.$refs.input);
        }
    },
    methods: {
        onChange() {
            this.$emit('change');

            if (this.tag === 'textarea') {
                this.checkIfScrollable(this.$refs.input);
            }
        },
        updateValue(val) {
            this.$emit('input', this.name, val, this.id);

            this.onChangeDebounced();
        },
        checkIfScrollable(t) {
            if (t.clientHeight >= t.scrollHeight) {
                if (t.classList.contains('scrollable')) {
                    t.classList.remove('scrollable');
                }
            } else {
                if (!t.classList.contains('scrollable')) {
                    t.classList.add('scrollable');
                }
            }
        },
    },
};
</script>
<style scoped>
.readonly {
    background-color: lightgray;
}
</style>
